import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Signal,
  inject,
} from '@angular/core';

import { Clipboard } from '@angular/cdk/clipboard';
import { Environment, ENVIRONMENT } from '@web/config';
import {
  ExternalLinkComponent,
  Icon,
  IconComponent,
  NoDataComponent,
  ToastService,
} from '@web/shared/ui';
import { Tooltip } from 'primeng/tooltip';
import { AdminProductStatus } from '../../enums/admin-product-status';

@Component({
  selector: 'app-admin-product-link',
  imports: [ExternalLinkComponent, IconComponent, Tooltip, NoDataComponent],
  templateUrl: './admin-product-link.component.html',
  styleUrl: './admin-product-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminProductLinkComponent {
  private readonly environment = inject<Environment>(ENVIRONMENT);
  private readonly clipboard = inject(Clipboard);
  private readonly toast = inject(ToastService);

  public readonly slug = input.required<string>();
  public readonly status = input.required<AdminProductStatus>();

  protected readonly shouldShowAsLink = this.shouldShowAsLinkSignal();
  protected readonly link = this.linkSignal();
  protected readonly Icon = Icon;

  private linkSignal(): Signal<string> {
    return computed(() => {
      const { Shop } = this.environment.AppUrl;

      return `${Shop}/produkty/${this.slug()}`;
    });
  }

  public shouldShowAsLinkSignal(): Signal<boolean> {
    return computed(() => {
      return ![AdminProductStatus.Private, AdminProductStatus.Draft].includes(
        this.status(),
      );
    });
  }

  public handleCopyToClipboardClick(): void {
    this.clipboard.copy(this.link());

    this.toast.show((builder) =>
      builder.initSuccess('Adres URL został skopiowany do schowka.').build(),
    );
  }
}
